var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup169(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.393,
    height: 25.39,
    viewBox: "0 0 25.393 25.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    d: "M-447,190.6q0-3.753,0-7.507a2.844,2.844,0,0,1,3.037-3.037h15.08a2.843,2.843,0,0,1,3.038,3.037q0,7.54,0,15.08a2.845,2.845,0,0,1-3.037,3.038H-444a2.841,2.841,0,0,1-3-3Q-447,194.405-447,190.6Zm10.577-8.439q-3.654,0-7.309,0a1.061,1.061,0,0,0-1.163,1.171q0,7.292,0,14.584a1.072,1.072,0,0,0,1.18,1.19h14.584a1.069,1.069,0,0,0,1.181-1.189q0-7.275,0-14.551a1.075,1.075,0,0,0-1.2-1.2Z",
    transform: "translate(451.24 -175.824)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    "data-name": "Path 3461",
    d: "M-507.9,137.177a2.829,2.829,0,0,1-3.159-2.759c-.018-1.047,0-2.094,0-3.141q0-6.1,0-12.2a2.841,2.841,0,0,1,3.014-3.027q7.6,0,15.21,0a2.844,2.844,0,0,1,2.916,3.162h-15.189a2.648,2.648,0,0,0-2.788,2.774q0,7.39,0,14.78Z",
    transform: "translate(511.073 -116.047)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    d: "M-382.155,264.574a3.027,3.027,0,0,1,.256-.366q2.941-2.948,5.887-5.89a1.465,1.465,0,0,1,1.794-.4,1.749,1.749,0,0,1,1.085,1.792,1.841,1.841,0,0,1-.442.891q-3.751,3.8-7.541,7.555a1.465,1.465,0,0,1-2.178-.019q-1.111-1.108-2.2-2.238a1.483,1.483,0,0,1,0-2.134,1.568,1.568,0,0,1,1.658-.622,1.976,1.976,0,0,1,.727.423C-382.79,263.849-382.518,264.184-382.155,264.574Z",
    transform: "translate(394.223 -248.385)",
    fill: "#7a7a7a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup169);
export default __webpack_public_path__ + "static/media/Group 169.118f3ef06229dd9ded0dc67bfcd3570b.svg";
export { ForwardRef as ReactComponent };